import descriptions from "@/scripts/descriptions";

export default {
    get: function () {
        const other = [];
        const publicActions = [
            crossTabulation,
            logisticRegression
        ];

        return {
            public: {
                name: 'actions',
                menu: publicActions,
                other,
                index
            }
        }
    }
}

// to="/" class="page-link">BRFSS WEAT</brfss-router-link>
// to="/analysis" class="page-link">Analysis</brfss-router-link>
// to="/crossTabulation" class="page-link">Cross Tabulation</brfss-router-link></li>
// to="/logisticRegression" class="page-link">Logistic Regression</brfss-router-link></li>

const crossTabulation = {
    showOnIndexPage: true,
    name: 'crossTabulationSelectYear',
    url: '/crossTabulation',
    title: 'Cross Tabulation',
    breadCrumbTitle: 'Cross Tabulation Years',
    description: 'Run a Cross Tabulation',
    detailedDescription: descriptions.crossTabulation
};


const logisticRegression = {
    showOnIndexPage: true,
    name: 'logisticRegressionSelectYear',
    url: '/logisticRegression',
    title: 'Logistic Regression',
    description: 'Run a Logistic Regression',
    detailedDescription: descriptions.logisticRegression
};

const index = {
    groupName: 'actions', //
    name: 'index',
    url: '/analysis', //
    title: 'Analysis', //
    isGroup: true
}
